export type MemberSection =
  | 'onboarding-snapshot'
  | 'annual-report'
  | 'action-plan'
  | 'ai-tools'
  | 'labs'
  | 'documents'
  | 'surveys'
  | 'omics-explorer';

export const MEMBER_SECTION_STORAGE_KEY = 'memberDetail.lastSection';
